export const aboutStatic = {
  crumbsNav: [
    { id: 1, title: 'Home', link: '/' },
    { id: 2, title: 'About', link: '/about/' },
  ],
};
